import { Globe } from 'lucide-react';
import { ForexPanel } from '@/components/paper-trading/ForexPanel';
import { forexLiveService } from '@/services/forexService';

/**
 * Live Trading page — real-money trading on funded broker accounts.
 *
 * Forex (FXCM) ships first. It reuses the same {@link ForexPanel} as the
 * Paper Trading → Forex tab, but pointed at the live API surface
 * (`forexLiveService` → `api/ForexLiveTrading/*`) and with `live` set,
 * which turns on the red real-money banner and the mandatory order
 * confirmation step.
 *
 * Equities (Alpaca live) is a planned follow-up — it would slot in here
 * as a second asset tab.
 */
export function LiveTradingPage() {
  return (
    <div className="p-5 space-y-5">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-lg bg-red-500/10 flex items-center justify-center">
          <Globe className="h-4 w-4 text-red-500" />
        </div>
        <div>
          <h2 className="text-lg font-semibold">Live Trading</h2>
          <span className="text-xs text-muted-foreground">
            Real-money forex on your funded FXCM account
          </span>
        </div>
      </div>
      <ForexPanel svc={forexLiveService} live />
    </div>
  );
}

export default LiveTradingPage;
